import { render, staticRenderFns } from "./BillPos.vue?vue&type=template&id=5be9d17c&scoped=true&"
import script from "./BillPos.vue?vue&type=script&lang=js&"
export * from "./BillPos.vue?vue&type=script&lang=js&"
import style0 from "./BillPos.vue?vue&type=style&index=0&id=5be9d17c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be9d17c",
  null
  
)

export default component.exports